export enum MessageType {
    Text,
    RichText,
    Job,
    Topic,
    TopicYesNo,
    EquipmentOptions,
    SearchEquipment,
    ManualEquipment,
    Question,
    CustomerInfo,
    LocationList,
    LocationDetail,
    JobList,
    JobDetails,
    EquipmentList,
    EquipmentDetails,
    Error,
    Feedback,
    FeedbackOptions,
    FeedbackDetails,
    Markdown,
    InvoiceList,
    InvoiceDetails,
    EstimateList,
    EstimateDetails,
    Button,
    DownloadDocuments,
    EquipmentAnswerCite,
    CalculatorForm,
    CalculationResult,
    /*
     * Appended (not inserted) so the values above keep matching the numeric `entity_type`
     * codes the function app sends; MidCallReport itself is only used frontend-locally.
     */
    MidCallReport,
    // replacement part finder specific message types
    ReplacementOEMPartSelect = 1000,
    ReplacementsList = 1001,
    CustomView = 10000,
}
